import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

export const LinkColumn = ({ children }: PropsWithChildren) => {
    return (
        <div
            css={css({
                display: "flex",
                flexDirection: "column"
            })}
        >
            {children}
        </div>
    );
};
